import { Route, Routes } from "react-router-dom";
import { Home } from "./pages/home/home";
import { Shared } from "./pages/shared/shared";
import './styled.css';
import { lazy } from "react";

const Movies = lazy(() => import("./pages/movie/movie"));
const MovieDetails = lazy(() => import("./pages/movieDatails/movieDatails"));
const Cast = lazy(() => import("./pages/cast/cast"));
const Reviews = lazy(() => import("./pages/reviews/reviews"));

export const App = () => {
    return (
            <Routes>
                <Route path="/" element={<Shared />}>
                    <Route index element={<Home />} />
                    <Route path="movies" element={<Movies />} />
                    <Route path="movies/:movieId" element={<MovieDetails />}>
                        <Route path="cast" element={<Cast />} />
                        <Route path="reviews" element={<Reviews />} />
                    </Route>
                </Route>
            </Routes>
    );
};
